import { createFileRoute } from '@tanstack/react-router';

/**
 * Tarefas do módulo Pipeline — filtra por vínculo de Deal (§7 do brief Portal Vega Bloco 1).
 * Componente vem de pipeline.tarefas.lazy.tsx (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/pipeline/tarefas')({});
